module.exports = __webpack_public_path__ + "assets/7fac8f0b8d5054f11f37b9d02cb6111c.png";